export default __webpack_public_path__ + "static/media/school_default.a489b2da.svg";